import { Redirect } from 'react-router-dom';

import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'query-string';

export const generateSRStatisticsUrl = (pmcId, buildingId) => {
  if (!pmcId && !buildingId) return null;
  const propertyType = buildingId ? 'building' : 'pmc';
  const propertyId = buildingId || pmcId;
  const sevenDaysAgo = moment().subtract(7, 'days').startOf('day');
  const date = `${sevenDaysAgo.format('YYYY-MM-DD')}T00:00:00`;
  if (!propertyType || !propertyId) return null;
  return `/${propertyType}/${propertyId}/service-requests?created_at_before=${date}&limit=25&offset=0&ordering=-updated_at&${propertyType}=${propertyId}&q&status=pending`;
};

// 'undefined' (as a string) might be received for id
const isValidId = (id) => !Number.isNaN(Number(id));

const generatePersonUrl = (
  roleId,
  personId,
  personRoleId,
  pmcId,
  buildingId,
) => {
  if (!roleId || !personId || !isValidId(personId)) return null;
  let url = null;
  switch (roleId) {
    case '1':
    case '2':
    case '3':
    case '8':
      url = isValidId(buildingId)
        ? `/building/${buildingId}/staff/${personId}`
        : isValidId(pmcId)
        ? `/pmc/${pmcId}/staff/${personId}`
        : null;
      break;
    case '4':
    case '5':
    case '7':
      url = isValidId(buildingId)
        ? `/building/${buildingId}/residents/${personId}`
        : null;
      break;
    case '6':
    case '9':
      url = isValidId(personRoleId)
        ? `/visitors/profile/${personRoleId}`
        : null;
      break;
    default:
      break;
  }
  return url;
};

const generateActivityUrl = (actionType, startDate, endDate) => {
  if (!actionType) return null;
  let url = null;

  switch (actionType) {
    case 'view_camera':
      url = `/carson-activity?action_name=view_camera&created_at_after=${startDate}&created_at_before=${endDate}&limit=25&offset=0&q`;
      break;
    case 'message_send':
      url = `/carson-activity?action_name=message_send&created_at_after=${startDate}&created_at_before=${endDate}&limit=25&offset=0&q`;
      break;
    default:
      break;
  }
  return url;
};

const RedirectComponent = ({ location }) => {
  const params = queryString.parse(location?.search);
  const {
    type,
    startDate,
    endDate,
    actionType,
    pmcId,
    buildingId,
    personId,
    roleId,
    personRoleId,
    url,
    key,
    branch_link,
    token,
  } = params;
  let redirectUrl = null;
  // link types - sr, person, activity, notification, messages, asset

  if (!type) return <Redirect to="/" />;
  switch (type) {
    case 'sr':
      redirectUrl = generateSRStatisticsUrl(pmcId, buildingId);
      break;
    case 'person':
      redirectUrl = generatePersonUrl(
        roleId,
        personId,
        personRoleId,
        pmcId,
        buildingId,
      );
      break;
    case 'activity':
      redirectUrl = generateActivityUrl(actionType, startDate, endDate); // add pmc and building?
      break;
    case 'notification':
    case 'messages':
      redirectUrl = `/${url}`;
      break;
    case 'asset':
      redirectUrl = `/asset/${key}${
        branch_link ? `/?branch_link=${branch_link}` : ``
      }`;
      break;
    case 'front_desk':
      redirectUrl = {
        pathname: `/delivery-self-sign-out`,
        search: `?token=${token}&buildingId=${buildingId}`,
      };
      break;
    default:
      return <Redirect to="/" />;
  }

  return redirectUrl ? <Redirect to={redirectUrl} /> : <Redirect to="/" />;
};

RedirectComponent.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
};

export default RedirectComponent;
